/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useState, useContext } from 'react';
import {
    bool, node, object, string,
} from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { CrossMerch } from '../CrossMerchContainer/CrossMerchContainer';

const styles = () => ({
    imageSection: {
        maxWidth: '100%',
        '&:hover': {
            opacity: 0,
        },
    },
    figure: {
        backgroundRepeat: 'no-repeat',
        margin: 0,
    },
});

const InnerZoom = ({
    classes, enableZoom, children, magnifiedImageSrc, containerId,
}) => {
    const { featureFlags = {} } = useContext(CrossMerch);
    const [figureProps, setFigure] = useState({
        backgroundImage: `url(${magnifiedImageSrc})`,
        backgroundPosition: '0% 0%',
    });

    const handleMouseMove = (event) => {
        const {
            left, top, width, height,
        } = event.target.getBoundingClientRect();
        const xAxis = ((event.pageX - left) / width) * 100;
        const yAxis = featureFlags['pdp-image-sticky'] ? 90 : ((event.pageY - top) / height) * 100;
        setFigure({ backgroundPosition: `${xAxis}% ${yAxis}%`, backgroundImage: `url(${magnifiedImageSrc})` });
    };

    if (!enableZoom || !magnifiedImageSrc) {
        return (
            <>
                {children}
            </>
        );
    }
    return (
        <figure id={`figure-inner-zoom${containerId}`} className={classes.figure} onMouseMove={handleMouseMove} style={figureProps}>
            <div className={classes.imageSection}>
                {children}
            </div>
        </figure>
    );
};

InnerZoom.propTypes = {
    classes: object.isRequired,
    enableZoom: bool,
    children: node,
    magnifiedImageSrc: string,
    containerId: string,
};

InnerZoom.defaultProps = {
    enableZoom: false,
    children: null,
    magnifiedImageSrc: null,
    containerId: '',
};

const enhance = compose(
    withStyles(styles),
);
export default enhance(InnerZoom);
